import { render, staticRenderFns } from "./AddSubstanceModal.vue?vue&type=template&id=8e31971e&"
import script from "./AddSubstanceModal.vue?vue&type=script&lang=js&"
export * from "./AddSubstanceModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSubstanceModal.vue?vue&type=style&index=0&id=8e31971e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports